import React, { useState, useEffect, useRef } from 'react';
import { ArrowRight, RotateCcw, Play, Pause, MousePointer, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const carImages = [
  "/assets/car1.webp",
  "/assets/car5.webp",
  "/assets/car6.webp",
  "/assets/car7.webp",
  "/assets/car8.webp",
  "/assets/car9.webp",
  "/assets/car10.webp",
  "/assets/car2.webp",
  "/assets/car3.webp",
  "/assets/car4.webp",
  
  "/assets/car5.webp",
  "/assets/car6.webp",
  "/assets/car7.webp",
  "/assets/car8.webp",
  "/assets/car9.webp",
  "/assets/car10.webp",
  "/assets/car1.webp",
  "/assets/car2.webp",
  "/assets/car3.webp",
  "/assets/car4.webp",
  "/assets/car5.webp",
  "/assets/car6.webp",
  "/assets/car7.webp",
  "/assets/car5.webp",
  "/assets/car6.webp",
  "/assets/car7.webp",
  "/assets/car8.webp",
  "/assets/car9.webp",
  "/assets/car10.webp",
  "/assets/car8.webp",
  "/assets/car9.webp",
  "/assets/car10.webp",
  "/assets/car1.webp",
  "/assets/car2.webp",
  "/assets/car3.webp",
  "/assets/car4.webp",
  "/assets/car5.webp",
  "/assets/car6.webp",
  "/assets/car7.webp",
  "/assets/car8.webp",
  "/assets/car9.webp",
  "/assets/car10.webp",
];

const Premium360Viewer = ({ viewMode = 'desktop' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoRotating, setIsAutoRotating] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [hasInteracted, setHasInteracted] = useState(false);
  const isDragging = useRef(false);
  const lastX = useRef(0);
  const autoRotateInterval = useRef(null);

  useEffect(() => {
    // Simulate loading with staggered effect
    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isAutoRotating) {
      autoRotateInterval.current = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % carImages.length);
      }, 400); // Slower rotation for better viewing (400ms per frame)
    } else {
      clearInterval(autoRotateInterval.current);
    }

    return () => clearInterval(autoRotateInterval.current);
  }, [isAutoRotating]);

  const handleMouseDown = (e) => {
    if (isAutoRotating) setIsAutoRotating(false);
    setHasInteracted(true);
    isDragging.current = true;
    lastX.current = e.clientX;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;

    const deltaX = e.clientX - lastX.current;
    const sensitivity = 3; // Reduce sensitivity for smoother control

    if (Math.abs(deltaX) > sensitivity) {
      const nextIndex = (currentIndex + (deltaX > 0 ? 1 : -1) + carImages.length) % carImages.length;
      setCurrentIndex(nextIndex);
      lastX.current = e.clientX;
    }
  };

  const handleTouchStart = (e) => {
    if (isAutoRotating) setIsAutoRotating(false);
    setHasInteracted(true);
    isDragging.current = true;
    lastX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();

    const deltaX = e.touches[0].clientX - lastX.current;
    const sensitivity = 3;

    if (Math.abs(deltaX) > sensitivity) {
      const nextIndex = (currentIndex + (deltaX > 0 ? 1 : -1) + carImages.length) % carImages.length;
      setCurrentIndex(nextIndex);
      lastX.current = e.touches[0].clientX;
    }
  };

  const handleTouchEnd = () => {
    isDragging.current = false;
  };

  const resetRotation = () => {
    setCurrentIndex(0);
    setIsAutoRotating(true);
  };

  return (
    // <div className="w-full h-96 flex flex-col  relative overflow-hidden rounded-lg bg-white">
    //   {/* Animated background */}
    //   {/* <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-purple-500/5 to-cyan-500/5 animate-pulse"></div> */}
      
    //   {/* Floating particles effect */}
    //   <div className="absolute inset-0 overflow-hidden pointer-events-none">
    //     <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-blue-400/30 rounded-full animate-bounce" style={{animationDelay: '0s'}}></div>
    //     <div className="absolute top-3/4 right-1/4 w-1 h-1 bg-purple-400/30 rounded-full animate-bounce" style={{animationDelay: '1s'}}></div>
    //     <div className="absolute bottom-1/4 left-3/4 w-1.5 h-1.5 bg-cyan-400/30 rounded-full animate-bounce" style={{animationDelay: '2s'}}></div>
    //   </div>

    //   {/* Main viewer area */}
      // <div 
      //   className={`flex-1 relative ${isDragging.current ? 'cursor-grabbing' : 'cursor-grab'} flex items-center justify-center p-6`}
      //   onMouseDown={handleMouseDown}
      //   onMouseUp={handleMouseUp}
      //   onMouseMove={handleMouseMove}
      //   onMouseLeave={handleMouseUp}
      //   onTouchStart={handleTouchStart}
      //   onTouchMove={handleTouchMove}
      //   onTouchEnd={handleTouchEnd}
      // >
    //     {isLoading ? (
    //       <div className="flex flex-col items-center space-y-6">
    //         <div className="relative">
    //           <div className="w-20 h-20 border-4 border-blue-500/30 rounded-full animate-spin"></div>
    //           <div className="absolute inset-0 w-20 h-20 border-4 border-t-blue-500 border-r-purple-500 border-b-cyan-500 border-l-transparent rounded-full animate-spin"></div>
    //         </div>
    //         <div className="text-center">
    //           <p className="text-gray-300 text-lg font-medium mb-2">Loading Premium Experience</p>
    //           <div className="flex items-center justify-center space-x-1">
    //             <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
    //             <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
    //             <div className="w-2 h-2 bg-cyan-500 rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
    //           </div>
    //         </div>
    //       </div>
    //     ) : (
    //       <>
    //         {/* Main image container */}
            
    //         <div className="relative group">

         
                           
    //           {/* <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-cyan-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-700"></div> */}
              
    //           <img
    //             src={carImages[currentIndex]}
    //             alt={`Car view ${currentIndex + 1}`}
    //             className="relative z-10 max-w-full max-h-full object-contain  transition-all duration-300 "
    //             draggable={false}
    //             style={{ maxHeight: '200px', maxWidth: '300px' }}
    //           />
    //         </div>
            
    //         {/* Floating controls */}
    //         {/* <div className="absolute top-6 right-6 flex flex-col space-y-3">
    //           <button
    //             onClick={resetRotation}
    //             className="group p-4 bg-black/80 backdrop-blur-xl text-white rounded-2xl hover:bg-black/90 transition-all duration-300 shadow-xl border border-gray-700/50 hover:border-blue-500/50"
    //             title="Reset rotation"
    //           >
    //             <RotateCcw className="w-5 h-5 group-hover:rotate-180 transition-transform duration-300" />
    //           </button>
    //           <button
    //             onClick={() => setIsAutoRotating(!isAutoRotating)}
    //             className="group p-4 bg-black/80 backdrop-blur-xl text-white rounded-2xl hover:bg-black/90 transition-all duration-300 shadow-xl border border-gray-700/50 hover:border-purple-500/50"
    //             title={isAutoRotating ? "Pause rotation" : "Auto rotate"}
    //           >
    //             {isAutoRotating ? 
    //               <Pause className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" /> : 
    //               <Play className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" />
    //             }
    //           </button>
    //         </div> */}

    //         {/* Progress indicator */}
    //         {/* <div className="absolute top-6 left-6 bg-black/80 backdrop-blur-xl text-white px-6 py-3 rounded-2xl text-sm font-medium shadow-xl border border-gray-700/50">
    //           <div className="flex items-center space-x-3">
    //             <div className="w-2 h-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full animate-pulse"></div>
    //             <span className="text-blue-400 font-bold">{currentIndex + 1}</span>
    //             <span className="text-gray-400">/</span>
    //             <span className="text-gray-300">{carImages.length}</span>
    //           </div>
    //         </div> */}

    //         {/* Enhanced interaction hint */}
    //         {/* {!hasInteracted && (
    //           <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-center animate-bounce">
    //             <div className="bg-gradient-to-r from-blue-500/90 to-purple-500/90 backdrop-blur-xl text-white px-8 py-4 rounded-2xl shadow-2xl border border-blue-400/30">
    //               <div className="flex items-center space-x-3">
    //                 <MousePointer className="w-5 h-5 animate-pulse" />
    //                 <span className="font-medium">
    //                   {viewMode === 'desktop' ? 'Drag to explore manually' : 'Swipe to control rotation'}
    //                 </span>
    //                 <Sparkles className="w-5 h-5 animate-pulse" />
    //               </div>
    //             </div>
    //           </div>
    //         )} */}

    //         {/* Status indicator */}
    //         {/* <div className="absolute bottom-6 right-6 flex items-center space-x-2">
    //           <div className={`w-3 h-3 rounded-full ${isAutoRotating ? 'bg-green-400 animate-pulse' : 'bg-amber-400'}`}></div>
    //           <span className="text-white/80 text-sm font-medium">
    //             {isAutoRotating ? 'Auto-rotating' : 'Manual'}
    //           </span>
    //         </div> */}
    //       </>
    //     )}
    //   </div>
    // </div>
    <div className="w-full h-[350px] bg-white rounded-[1.5rem] shadow-md relative overflow-hidden flex flex-col items-center justify-start p-4">

      {/* Floating Ad Badge (Optimized for mobile) */}
      <div className="z-10 mb-2">
        <div className="bg-black text-white px-4 py-1.5 rounded-full text-xs font-semibold flex items-center gap-2 shadow-sm">
          <span className="text-base">🚗</span>
          <span> Cars Ad – Explore All Sides</span>
        </div>
      </div>
      <div 
        className={`flex-1 relative ${isDragging.current ? 'cursor-grabbing' : 'cursor-grab'} flex items-center justify-center p-6`}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
      {/* Car Image */}
      <div className="relative z-10 flex items-center justify-center w-full h-full">
        <img
          src={carImages[currentIndex]}
          alt={`Car View ${currentIndex + 1}`}
          className="max-h-[360px] max-w-full object-contain transition-all duration-200"
          draggable={false}
          style={{ maxHeight: '200px', maxWidth: '300px' }}
        />
      </div>

      {/* Subtle glow particles */}
      <div className="absolute inset-0 pointer-events-none z-0">
        <div className="absolute top-[25%] left-[30%] w-1.5 h-1.5 bg-blue-400/20 rounded-full animate-ping" />
        <div className="absolute bottom-[15%] right-[25%] w-2 h-2 bg-purple-400/20 rounded-full animate-ping delay-200" />
        <div className="absolute top-[70%] left-[60%] w-1.5 h-1.5 bg-cyan-400/20 rounded-full animate-ping delay-500" />
      </div>
    </div>
    </div>
  );
};

function App() {
  const [isMobile, setIsMobile] = useState(true);

  return (
    <>
    <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-8 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Every Angle. Every Detail. Fully Interactive.
                  </h1>
                  <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                  360 Rotate
                  </span>
                </div>
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                BRING YOUR PRODUCT TO LIFE
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                This 360° ad experience lets users explore your product from all sides with smooth drag controls and auto-play rotation. Whether it's a car, gadget, or premium item, it turns static visuals into immersive showcases. Just upload your assets and launch an interactive format that keeps users engaged and curious.
                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
                </Link>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            {/* Preview toggle */}
            <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-3">
                      <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                      </button>
                      <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>
           
            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs">
                  {/* iPhone mockup */}
                  <div className="relative bg-gray-200 rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          360-car-viewer.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                        {/* 360 Viewer - Full screen on mobile */}
                        <div className="space-y-3">
                    <div className="h-3 bg-gray-200 rounded w-full"></div>
                    <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                    <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                  </div>
                  <div className="mb-6">
                  <div className="relative group transform transition-all duration-300 rounded-lg overflow-hidden">
                          <Premium360Viewer viewMode="mobile" />
                        </div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup */}
              {!isMobile && (
                <div className="w-full max-w-4xl mx-auto hidden lg:block">
                  {/* Desktop Screen Frame */}
                  <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                    {/* Screen */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                      {/* macOS-style window header */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center border-b border-gray-200">
                        <div className="flex space-x-2">
                          <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                        </div>
                        <div className="flex-1 mx-2">
                          <div className="bg-white rounded-md px-2 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                            🔒 360-car-viewer.com
                          </div>
                        </div>
                        <div className="flex space-x-2">
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      {/* Content area */}
                      {/* <div className="p-4 bg-gray-50 min-h-[100px]"> */}
                      <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          

                        </div>
                      {/* Browser content area */}
                      <div className="bg-gray-50  h-[500px] overflow-y-auto hide-scrollbar">
                        {/* 360 Viewer centered on desktop */}
                        <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>

                          </div>
                        <div className="flex justify-center ">
                          <div className="w-full max-w-md">
                            <Premium360Viewer viewMode="desktop" />
                          </div>
                        {/* </div> */}
                      </div>
                       {/* Additional content placeholders */}
                       <div className="grid grid-cols-2 gap-6 mb-6 mt-2">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3 mt-2">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                              {/* Additional content placeholders */}
                              <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                    </div>
                    </div>
                  </div>
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-slide-up {
          animation: slide-up 0.8s ease-out;
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
      `}</style>
    </div>
<div className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {/* Card 1 */}
        <Link to="/scratch-to-win/hm" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
          <img
            src="/assets/sc.avif"
            alt="Card 1"
            className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
            <h2 className="text-lg font-semibold">Scratch TO Win</h2>
          </div>
        </Link>

        {/* Card 2 */}
        <Link to="/swipe-to-reveal/pizza" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
          <img
            src="/assets/sw.jpg"
            alt="Card 2"
            className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
            <h2 className="text-lg font-semibold">Swipe to Reveal</h2>
          </div>
        </Link>

        {/* Card 3 */}
        <Link to="/tap-to-reveal/thumsup" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
          <img
            src="/assets/tmmm.png"
            alt="Card 3"
            className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
            <h2 className="text-lg font-semibold">Tap to Reveal</h2>
          </div>
        </Link>

        {/* Card 4 */}
        <Link to="/interactive-selector/travel-ramadan" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
          <img
            src="/assets/du.jpg"
            alt="Card 4"
            className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
            <h2 className="text-lg font-semibold">Dubai Travel</h2>
          </div>
        </Link>

       
      </div>
    </div>

    </>
  );
}

export default App;

// import React, { useState, useRef, useEffect } from "react";
// import { RotateCcw, Smartphone, Monitor, Play, Pause, Eye, Zap, MousePointer, Sparkles } from "lucide-react";

// const carImages = [
//   "/assets/car1.webp",
//   "/assets/car2.webp",
//   "/assets/car3.webp",
//   "/assets/car4.webp",
//   "/assets/car5.webp",
//   "/assets/car6.webp",
//   "/assets/car7.webp",
//   "/assets/car8.webp",
//   "/assets/car9.webp",
//   "/assets/car10.webp",
//   "/assets/car1.webp",
//   "/assets/car2.webp",
//   "/assets/car3.webp",
//   "/assets/car4.webp",
//   "/assets/car5.webp",
//   "/assets/car6.webp",
//   "/assets/car7.webp",
//   "/assets/car8.webp",
//   "/assets/car9.webp",
//   "/assets/car10.webp",
//   "/assets/car1.webp",
//   "/assets/car2.webp",
//   "/assets/car3.webp",
//   "/assets/car4.webp",
//   "/assets/car5.webp",
//   "/assets/car6.webp",
//   "/assets/car7.webp",
//   "/assets/car8.webp",
//   "/assets/car9.webp",
//   "/assets/car10.webp",
// ];

// const Premium360Viewer = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isAutoRotating, setIsAutoRotating] = useState(true);
//   const [viewMode, setViewMode] = useState('desktop');
//   const [isLoading, setIsLoading] = useState(true);
//   const [hasInteracted, setHasInteracted] = useState(false);
//   const isDragging = useRef(false);
//   const lastX = useRef(0);
//   const autoRotateInterval = useRef(null);

//   useEffect(() => {
//     // Simulate loading with staggered effect
//     const timer = setTimeout(() => setIsLoading(false), 1500);
//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     if (isAutoRotating) {
//       autoRotateInterval.current = setInterval(() => {
//         setCurrentIndex(prev => (prev + 1) % carImages.length);
//       }, 400); // Slower rotation for better viewing (400ms per frame)
//     } else {
//       clearInterval(autoRotateInterval.current);
//     }

//     return () => clearInterval(autoRotateInterval.current);
//   }, [isAutoRotating]);

//   const handleMouseDown = (e) => {
//     if (isAutoRotating) setIsAutoRotating(false);
//     setHasInteracted(true);
//     isDragging.current = true;
//     lastX.current = e.clientX;
//   };

//   const handleMouseUp = () => {
//     isDragging.current = false;
//   };

//   const handleMouseMove = (e) => {
//     if (!isDragging.current) return;

//     const deltaX = e.clientX - lastX.current;
//     const sensitivity = 3; // Reduce sensitivity for smoother control

//     if (Math.abs(deltaX) > sensitivity) {
//       const nextIndex = (currentIndex + (deltaX > 0 ? 1 : -1) + carImages.length) % carImages.length;
//       setCurrentIndex(nextIndex);
//       lastX.current = e.clientX;
//     }
//   };

//   const handleTouchStart = (e) => {
//     if (isAutoRotating) setIsAutoRotating(false);
//     setHasInteracted(true);
//     isDragging.current = true;
//     lastX.current = e.touches[0].clientX;
//   };

//   const handleTouchMove = (e) => {
//     if (!isDragging.current) return;
//     e.preventDefault();

//     const deltaX = e.touches[0].clientX - lastX.current;
//     const sensitivity = 3;

//     if (Math.abs(deltaX) > sensitivity) {
//       const nextIndex = (currentIndex + (deltaX > 0 ? 1 : -1) + carImages.length) % carImages.length;
//       setCurrentIndex(nextIndex);
//       lastX.current = e.touches[0].clientX;
//     }
//   };

//   const handleTouchEnd = () => {
//     isDragging.current = false;
//   };

//   const resetRotation = () => {
//     setCurrentIndex(0);
//     setIsAutoRotating(true);
//   };

//   const ViewerContent = () => (
//     <div className="w-full h-full flex flex-col bg-gradient-to-br from-slate-900 via-gray-900 to-slate-800 relative overflow-hidden">
//       {/* Animated background */}
//       <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-purple-500/5 to-cyan-500/5 animate-pulse"></div>
      
//       {/* Floating particles effect */}
//       <div className="absolute inset-0 overflow-hidden pointer-events-none">
//         <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-blue-400/30 rounded-full animate-bounce" style={{animationDelay: '0s'}}></div>
//         <div className="absolute top-3/4 right-1/4 w-1 h-1 bg-purple-400/30 rounded-full animate-bounce" style={{animationDelay: '1s'}}></div>
//         <div className="absolute bottom-1/4 left-3/4 w-1.5 h-1.5 bg-cyan-400/30 rounded-full animate-bounce" style={{animationDelay: '2s'}}></div>
//       </div>

//       {/* Main viewer area */}
//       <div 
//         className={`flex-1 relative ${isDragging.current ? 'cursor-grabbing' : 'cursor-grab'} flex items-center justify-center p-6`}
//         onMouseDown={handleMouseDown}
//         onMouseUp={handleMouseUp}
//         onMouseMove={handleMouseMove}
//         onMouseLeave={handleMouseUp}
//         onTouchStart={handleTouchStart}
//         onTouchMove={handleTouchMove}
//         onTouchEnd={handleTouchEnd}
//       >
//         {isLoading ? (
//           <div className="flex flex-col items-center space-y-6">
//             <div className="relative">
//               <div className="w-20 h-20 border-4 border-blue-500/30 rounded-full animate-spin"></div>
//               <div className="absolute inset-0 w-20 h-20 border-4 border-t-blue-500 border-r-purple-500 border-b-cyan-500 border-l-transparent rounded-full animate-spin"></div>
//             </div>
//             <div className="text-center">
//               <p className="text-gray-300 text-lg font-medium mb-2">Loading Premium Experience</p>
//               <div className="flex items-center justify-center space-x-1">
//                 <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
//                 <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
//                 <div className="w-2 h-2 bg-cyan-500 rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
//               </div>
//             </div>
//           </div>
//         ) : (
//           <>
//             {/* Main image container */}
//             <div className="relative group">
//               <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-cyan-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-700"></div>
//               <img
//                 src={carImages[currentIndex]}
//                 alt={`Car view ${currentIndex + 1}`}
//                 className="relative z-10 max-w-full max-h-full object-contain drop-shadow-2xl rounded-lg transition-all duration-300 group-hover:scale-105"
//                 draggable={false}
//               />
//             </div>
            
//             {/* Floating controls */}
//             <div className="absolute top-6 right-6 flex flex-col space-y-3">
//               <button
//                 onClick={resetRotation}
//                 className="group p-4 bg-black/80 backdrop-blur-xl text-white rounded-2xl hover:bg-black/90 transition-all duration-300 shadow-xl border border-gray-700/50 hover:border-blue-500/50"
//                 title="Reset rotation"
//               >
//                 <RotateCcw className="w-5 h-5 group-hover:rotate-180 transition-transform duration-300" />
//               </button>
//               <button
//                 onClick={() => setIsAutoRotating(!isAutoRotating)}
//                 className="group p-4 bg-black/80 backdrop-blur-xl text-white rounded-2xl hover:bg-black/90 transition-all duration-300 shadow-xl border border-gray-700/50 hover:border-purple-500/50"
//                 title={isAutoRotating ? "Pause rotation" : "Auto rotate"}
//               >
//                 {isAutoRotating ? 
//                   <Pause className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" /> : 
//                   <Play className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" />
//                 }
//               </button>
//             </div>

//             {/* Progress indicator */}
//             {/* <div className="absolute top-6 left-6 bg-black/80 backdrop-blur-xl text-white px-6 py-3 rounded-2xl text-sm font-medium shadow-xl border border-gray-700/50">
//               <div className="flex items-center space-x-3">
//                 <div className="w-2 h-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full animate-pulse"></div>
//                 <span className="text-blue-400 font-bold">{currentIndex + 1}</span>
//                 <span className="text-gray-400">/</span>
//                 <span className="text-gray-300">{carImages.length}</span>
//               </div>
//             </div> */}

//             {/* Enhanced interaction hint */}
//             {!hasInteracted && (
//               <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-center animate-bounce">
//                 <div className="bg-gradient-to-r from-blue-500/90 to-purple-500/90 backdrop-blur-xl text-white px-8 py-4 rounded-2xl shadow-2xl border border-blue-400/30">
//                   <div className="flex items-center space-x-3">
//                     <MousePointer className="w-5 h-5 animate-pulse" />
//                     <span className="font-medium">
//                       {viewMode === 'desktop' ? 'Drag to explore manually' : 'Swipe to control rotation'}
//                     </span>
//                     <Sparkles className="w-5 h-5 animate-pulse" />
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Status indicator */}
//             <div className="absolute bottom-6 right-6 flex items-center space-x-2">
//               <div className={`w-3 h-3 rounded-full ${isAutoRotating ? 'bg-green-400 animate-pulse' : 'bg-amber-400'}`}></div>
//               <span className="text-white/80 text-sm font-medium">
//                 {isAutoRotating ? 'Auto-rotating' : 'Manual'}
//               </span>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );

//   return (
//     <div className="mt-16  min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 relative overflow-hidden">
//       {/* Enhanced background effects */}
//       <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-purple-500/10 to-cyan-500/10"></div>
//       <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-full filter blur-3xl animate-pulse"></div>
//       <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-br from-purple-500/20 to-cyan-500/20 rounded-full filter blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
//       <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-full filter blur-2xl animate-pulse" style={{animationDelay: '2s'}}></div>
      
//       <div className="relative z-10 p-6 lg:p-12">
//         {/* Enhanced Header */}
//         <div className="text-center mb-12">
//           <div className="flex justify-center mb-4">
//             <div className="relative">
//               <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl flex items-center justify-center shadow-xl">
//                 <Eye className="w-8 h-8 text-white" />
//               </div>
//               <div className="absolute -top-1 -right-1 w-6 h-6 bg-gradient-to-r from-purple-500 to-cyan-500 rounded-full flex items-center justify-center">
//                 <Sparkles className="w-3 h-3 text-white" />
//               </div>
//             </div>
//           </div>
//           <h1 className="text-5xl lg:text-7xl font-bold bg-gradient-to-r from-gray-800 via-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">
//             Premium 360° Experience
//           </h1>
//           <p className="text-gray-600 text-xl lg:text-2xl max-w-2xl mx-auto leading-relaxed">
//             Immerse yourself in an interactive automotive showcase with premium viewing experience
//           </p>
//         </div>

//         {/* Enhanced Device Toggle */}
//         <div className="flex justify-center mb-12">
//           <div className="bg-white/90 backdrop-blur-xl rounded-3xl p-3 shadow-2xl border border-white/50">
//             <div className="flex space-x-2">
//               <button
//                 onClick={() => setViewMode('desktop')}
//                 className={`flex items-center space-x-3 px-8 py-4 rounded-2xl transition-all duration-300 font-semibold ${
//                   viewMode === 'desktop' 
//                     ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg transform scale-105 shadow-blue-500/25' 
//                     : 'text-gray-600 hover:bg-gray-50 hover:scale-105'
//                 }`}
//               >
//                 <Monitor className="w-6 h-6" />
//                 <span>Desktop View</span>
//               </button>
//               <button
//                 onClick={() => setViewMode('mobile')}
//                 className={`flex items-center space-x-3 px-8 py-4 rounded-2xl transition-all duration-300 font-semibold ${
//                   viewMode === 'mobile' 
//                     ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg transform scale-105 shadow-purple-500/25' 
//                     : 'text-gray-600 hover:bg-gray-50 hover:scale-105'
//                 }`}
//               >
//                 <Smartphone className="w-6 h-6" />
//                 <span>Mobile View</span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Enhanced Device Mockup */}
//         <div className="flex justify-center mb-12">
//           {viewMode === 'desktop' ? (
//             <div className="relative max-w-6xl w-full">
//               {/* Desktop mockup with enhanced styling */}
//               <div className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-t-3xl p-8 shadow-2xl border border-gray-700">
//                 <div className="flex items-center space-x-2 mb-4">
//                   <div className="w-3 h-3 bg-red-500 rounded-full"></div>
//                   <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
//                   <div className="w-3 h-3 bg-green-500 rounded-full"></div>
//                 </div>
//                 <div className="bg-black rounded-2xl p-4 shadow-inner">
//                   <div className="w-full h-[70vh] lg:h-[85vh] bg-gray-900 rounded-xl overflow-hidden ring-1 ring-gray-700 shadow-2xl">
//                     <ViewerContent />
//                   </div>
//                 </div>
//               </div>
//               {/* Enhanced desktop stand */}
//               <div className="bg-gradient-to-b from-gray-700 to-gray-800 h-16 w-48 mx-auto rounded-b-3xl shadow-xl"></div>
//               <div className="bg-gradient-to-b from-gray-600 to-gray-700 h-6 w-64 mx-auto rounded-full shadow-xl"></div>
//             </div>
//           ) : (
//             <div className="relative">
//               {/* Enhanced mobile mockup */}
//               <div className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-[3rem] p-4 shadow-2xl border border-gray-700">
//                 <div className="bg-black rounded-[2.5rem] p-3 shadow-inner">
//                   <div className="w-80 h-[70vh] bg-gray-900 rounded-[2rem] overflow-hidden ring-1 ring-gray-700 shadow-2xl">
//                     <ViewerContent />
//                   </div>
//                 </div>
//               </div>
//               {/* Enhanced mobile reflection */}
//               <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-transparent to-transparent rounded-[3rem] pointer-events-none"></div>
//             </div>
//           )}
//         </div>

//         {/* Enhanced Feature highlights */}
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
//             <div className="group bg-white/80 backdrop-blur-xl rounded-3xl p-8 shadow-xl border border-white/50 hover:shadow-2xl transition-all duration-300 hover:scale-105">
//               <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl mx-auto mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
//                 <Eye className="w-8 h-8 text-white" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Complete 360° View</h3>
//               <p className="text-gray-600 leading-relaxed">Experience every angle with our premium spherical viewing technology and ultra-smooth rotation</p>
//             </div>
//             <div className="group bg-white/80 backdrop-blur-xl rounded-3xl p-8 shadow-xl border border-white/50 hover:shadow-2xl transition-all duration-300 hover:scale-105">
//               <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-cyan-500 rounded-2xl mx-auto mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
//                 <Zap className="w-8 h-8 text-white" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Smart Auto-Play</h3>
//               <p className="text-gray-600 leading-relaxed">Intelligent automatic rotation optimized for 10 frames with seamless manual override control</p>
//             </div>
//             <div className="group bg-white/80 backdrop-blur-xl rounded-3xl p-8 shadow-xl border border-white/50 hover:shadow-2xl transition-all duration-300 hover:scale-105">
//               <div className="w-16 h-16 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl mx-auto mb-6 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
//                 <Smartphone className="w-8 h-8 text-white" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-3">Universal Compatibility</h3>
//               <p className="text-gray-600 leading-relaxed">Flawless performance across all devices - desktop, tablet, and mobile with touch optimization</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Premium360Viewer;